<script lang="ts">
  import { afterNavigate } from "$app/navigation";

  import { tick } from "svelte";

  import Footer from "$lib/ui/common/Footer.svelte";
  import StickyHeader from "$lib/ui/common/StickyHeader.svelte";
  import DocsNavbar from "$lib/ui/docs/DocsNavbar.svelte";

  afterNavigate(async () => {
    const hash = window.location.hash;
    if (hash) {
      await tick(); // without this, element is null because the DOM isn't updated yet
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  });
</script>

<div class="min-h-screen flex flex-col">
  <StickyHeader>
    <DocsNavbar />
  </StickyHeader>
  <slot />
  <Footer />
</div>
